export default __webpack_public_path__ + "34b49f334f41cea8e3655802530d4c67.woff2";